import _objectWithoutProperties from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["servicesResourcesIds"],
  _excluded2 = ["servicesResourcesIds"];
import { handleError, handleSuccess, triggerGet, triggerPost, triggerPut } from './utils';

// Get all Services
const getAllServicesApiRequest = async providerId => {
  const apiResponse = await triggerGet(providerId ? "/public/providers/".concat(providerId, "/services") : '/business/services', !providerId);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    const {
      data
    } = handleSuccess(responseData);
    const newData = data.filter(x => !providerId || x.servicesActive === 'Y');
    return {
      success: true,
      data: newData
    };
  }
  return handleError(responseData);
};

// Get all OneTime services
const getOneTimeApiRequest = async () => {
  const apiResponse = await triggerGet('/business/services/N');
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Archive a Service
const deleteServiceApiRequest = async (id, status) => {
  const apiResponse = await triggerGet("/business/services/archive/".concat(id));
  if (apiResponse.status === 200) {
    if (status) {
      return toggleActiveStatusApiRequest(id);
    }
    return {
      success: true,
      data: [],
      report: {}
    };
  }
  return {
    success: false
  };
};
const toggleActiveStatusApiRequest = async id => {
  const apiResponse = await triggerGet("/business/services/status/".concat(id));
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return {
      success: true,
      data: [],
      report: {}
    };
  }
  return handleError(responseData);
};

// Create a Service/Course
const createServiceApiRequest = async data => {
  const {
      servicesResourcesIds
    } = data,
    rest = _objectWithoutProperties(data, _excluded);
  const ids = typeof servicesResourcesIds === 'string' ? servicesResourcesIds : servicesResourcesIds.map(x => x).join(',');
  const apiResponse = await triggerPost('/business/services', rest);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return assignResourcesToServiceApiRequest(responseData.report.newid, ids);
  }
  return handleError(responseData);
};

// Assign personnel to Services and Subservices

const assignResourcesToServiceApiRequest = async (id, ids) => {
  const apiResponse = await triggerPost("/business/services/".concat(id, "/resources"), {
    servicesResourcesIds: ids
  });
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Update a Service/Course
const updateServiceApiRequest = async data => {
  const {
      servicesResourcesIds
    } = data,
    rest = _objectWithoutProperties(data, _excluded2);
  const ids = typeof servicesResourcesIds === 'string' ? servicesResourcesIds : servicesResourcesIds.map(x => x).join(',');
  const apiResponse = await triggerPut("/business/services/".concat(rest.servicesId), rest);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return assignResourcesToServiceApiRequest(rest.servicesId, ids);
  }
  return handleError(responseData);
};

// Get the Archived Services by type
const getArchivedServices = async type => {
  const apiResponse = await triggerGet("/business/services/".concat(type, "/archive"));
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Get the Archived Courses
const getArchivedCourses = async () => {
  const apiResponse = await triggerGet('/business/services/Y/archive');
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};
const getEventsApiRequest = async () => {
  const apiResponse = await triggerGet('/business/services/E');
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};
const getCoursesApiRequest = async () => {
  const apiResponse = await triggerGet('/business/services/Y');
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};
export { getCoursesApiRequest, getEventsApiRequest, getArchivedCourses, deleteServiceApiRequest, createServiceApiRequest, updateServiceApiRequest, getArchivedServices, getAllServicesApiRequest, getOneTimeApiRequest, toggleActiveStatusApiRequest };